export default __webpack_public_path__ + "static/media/white.a118fe38.svg";